import { Component } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
    constructor() { }

    static componentName = 'HeaderComponent';

    showSidebar() {
        const wrapEl = document.querySelectorAll('div.site-wrap');
        const headerEl = document.querySelectorAll('header.site-header');
        const menuEl = document.querySelectorAll('ul.menu');
        const bodyEl = document.querySelectorAll('body');

        if (wrapEl[0].classList.contains('sidebar')) {
            wrapEl[0].classList.remove('sidebar');
            headerEl[0].classList.remove('move-left');
            menuEl[0].classList.remove('open');
            bodyEl[0].classList.remove('menu-open');
        } else {
            wrapEl[0].classList.add('sidebar');
            headerEl[0].classList.add('move-left');
            menuEl[0].classList.add('open');
            bodyEl[0].classList.add('menu-open');
        }

    }

}



// WEBPACK FOOTER //
// E:/MBP/BloomyNG/src/app/header/header.component.ts